'use client';

import { useDrawer } from '@cat-ecom/pcc-components';
import { FC, PropsWithChildren, createContext, useContext } from 'react';

const FbtMobileDrawerContext =
  createContext<ReturnType<typeof useDrawer>>(null);
export const useFbtMobileDrawer = () => useContext(FbtMobileDrawerContext);

export const FBTMobileDrawerProvider: FC<PropsWithChildren> = ({
  children
}) => {
  const fbtMobileDrawer = useDrawer();

  return (
    <FbtMobileDrawerContext.Provider value={fbtMobileDrawer}>
      {children}
    </FbtMobileDrawerContext.Provider>
  );
};
